<template>
  <div>
    <!-- Botão send -->
    <div v-if="!loading" class="mt-5">
      <transition name="fade">
        <MenssageAlert :messages="messages" />
      </transition>
    </div>
    <div class="centralize" v-if="loading || loadingSend">
      <LoadingSpinner />
    </div>
    <!-- Balance -->
    <div v-if="!loading">
      <div class="px-3 mt-4 mb-2">
        <CRow>
          <CCol md="12" class="font-balance">
            {{ $t('campaign.campaignSummary.text.balance') }}
          </CCol>
          <CCol md="12" v-if="hasInsuficienteBalance">
            <div class="d-flex justify-content-start align-items-center text-warning pt-2 font-sm">
              <CIcon name="infoCircle" size="custom-size" class="mr-2" :height="16" style="transform: rotate(180deg)" viewBox="0 0 32 32" />
              {{ $t('campaign.campaignSummary.text.insuficienteBalance') }}
            </div>
          </CCol>
          <CCol md="12" v-if="hasReachedMaxDailySchedulingLimit">
            <div class="d-flex justify-content-start align-items-center text-warning pt-2 font-sm">
              <CIcon name="infoCircle" size="custom-size" class="mr-2" :height="16" style="transform: rotate(180deg)" viewBox="0 0 32 32" />
              {{ $t('campaign.campaignSummary.text.maxDailyLimitReached') }}
            </div>
          </CCol>
        </CRow>
      </div>
      <div class="resume-balance-area pt-4 pb-4 px-4">
        <!-- totalizações -->
        <center v-if="loading">
          <LoadingSpinner />
        </center>
        <div v-if="!loading" class="mb-2">
          <CRow class="" v-if="!emailValue.verification">
            <CCol>
              <div class="font-title-channels pt-2">
                <CIcon name="emailFull" size="custom-size" :height="25" viewBox="0 0 32 32" class="mr-2 pb-1" />
                {{ $t('campaign.campaignSummary.title.email') }}
              </div>
            </CCol>
            <CCol class="text-right font-title-values">
              <div class="d-flex justify-content-end align-items-center">
                <span class="text-warning mr-2 font-md" v-if="emailValue.remaining < 0"> ({{ emailValue.remaining }}) </span>
                {{ emailValue.balance }}
              </div>
            </CCol>
          </CRow>

          <CRow v-if="emailValue.remaining < 0">
            <CCol>
              <InsuficienteBalance />
            </CCol>
          </CRow>

          <CRow v-if="smsValue.length > 0" @click="showSMSLocations = !showSMSLocations" class="mt-2" style="cursor: pointer">
            <CCol>
              <div class="font-title-channels pt-2">
                <CIcon name="smsFull" size="custom-size" :height="25" viewBox="0 0 32 32" class="mr-2 pb-1" />
                {{ $t('campaign.campaignSummary.title.sms') }}
              </div>
            </CCol>
            <CCol class="text-right font-title-values">
              <div class="d-flex justify-content-end align-items-center">
                <span class="text-warning mr-2 font-md" v-if="totalSMS(smsValue).totalRemaining < 0">
                  ({{ totalSMS(smsValue).totalRemaining }})
                </span>
                {{ totalSMS(smsValue).totalToSend }}
              </div>
            </CCol>
          </CRow>
          <CRow v-if="smsValue.length > 0" class="mb-2">
            <CCol>
              <div @click="showSMSLocations = !showSMSLocations" style="cursor: pointer" class="d-flex justify-content-between">
                <span> {{ $t('campaign.campaignSummary.title.byDestinations') }} </span>
                <span>
                  <CIcon :class="showSMSLocations ? 'invert-icon' : ''" name="arrow" size="custom-size" :height="14" viewBox="0 0 32 32" />
                </span>
              </div>
              <CCollapse :show="showSMSLocations">
                <div v-if="!loading">
                  <div class="scroll-area-locations">
                    <div v-for="(country, index) in smsValue" :key="index" class="pt-3 pb-2 border-locations">
                      <!-- Em caso de destinos que não sejam o resto do mundo -->
                      <CRow v-if="country.countryId != 'RoW'">
                        <CCol sm="2" class="pl-1">
                          <img :src="getFlag(country.countryId)" width="30" />
                        </CCol>
                        <CCol sm="4" class="text-gray-600">
                          {{ country.countryId }}
                        </CCol>

                        <CCol sm="6" class="text-gray-base text-right pr-2">
                          <span v-if="country.remaining < 0" class="text-warning mr-2">
                            {{ `(${country.remaining})` }}
                          </span>
                          {{ country.balance }}
                        </CCol>
                      </CRow>
                      <!-- Em caso de destinos que sejam o resto do mundo -->
                      <CRow v-else>
                        <CCol sm="2" class="pl-1">
                          <img :src="getFlag(country.countryId.toUpperCase())" width="30" />
                        </CCol>
                        <CCol sm="4" class="text-gray-600">
                          {{ country.countryId }}
                        </CCol>

                        <CCol sm="4" class="text-gray-base text-right pr-2">
                          <span v-if="country.remaining < 0" class="text-warning mr-2">
                            {{ `(${country.remaining})` }}
                          </span>
                          {{ country.balance }}
                        </CCol>
                        <CCol sm="2" class="text-right">
                          <div class="" @click="showSMSRoWLocations = !showSMSRoWLocations" style="cursor: pointer">
                            <CIcon
                              :class="showSMSRoWLocations ? 'invert-icon' : ''"
                              name="arrow"
                              size="custom-size"
                              :height="14"
                              viewBox="0 0 32 32"
                            />
                          </div>
                        </CCol>
                      </CRow>
                      <CCollapse v-if="country.countryId == 'RoW'" :show="showSMSRoWLocations">
                        <div v-for="(item, i) in country.items" :key="i" class="pt-3 pb-2 border-locations">
                          <!-- Em caso de destinos que não sejam o resto do mundo -->
                          <CRow v-if="item.countryId != 'RoW'">
                            <CCol sm="1"></CCol>
                            <CCol sm="2" class="pl-1">
                              <img :src="getFlag(item.countryId)" width="30" />
                            </CCol>
                            <CCol sm="4" class="text-gray-600">
                              {{ item.countryId }}
                            </CCol>

                            <CCol sm="5" class="text-gray-base text-right pr-2">
                              <span v-if="item.remaining < 0" class="text-warning mr-2">
                                {{ `(${item.remaining})` }}
                              </span>
                              {{ item.balance }}
                            </CCol>
                          </CRow>
                        </div>
                      </CCollapse>
                    </div>
                  </div>
                </div>
              </CCollapse>
            </CCol>
          </CRow>
          <CRow v-if="smsValue.length > 0 && totalSMS(smsValue).totalRemaining < 0">
            <CCol>
              <InsuficienteBalance />
            </CCol>
          </CRow>
          <div class="mt-5 text-center">
            <div v-if="!loadingSend">
              <!-- <div
            v-if="campaignStatus != 'Scheduled'"
            class="send send-cursor mb-2 centralize"
            @click="sendCampaign(hasInsuficienteBalance)"
            :class="hasInsuficienteBalance ? 'disable-send ' : ''"
          >
            <CIcon style="margin-top: 14px" name="rocketSend" :height="45" viewBox="0 0 32 32" />
            <span class="textSend">SEND</span>
          </div> -->
              <CButton
                v-if="campaignStatus != 'Scheduled'"
                color="primary"
                class="px-5 py-2 border"
                :disabled="hasInsuficienteBalance || hasReachedMaxDailySchedulingLimit"
                @click="sendCampaign(hasInsuficienteBalance)"
              >
                {{ $t('campaign.campaignCreator.flow.button.send') }}
              </CButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import countries from '../../../../countriesList'
import LoadingSpinner from './LoadingSpinner.vue'
import MenssageAlert from '@/components/MenssageAlert'
import InsuficienteBalance from './InsuficienteBalance.vue'

import services from '@/services.js'

export default {
  components: {
    LoadingSpinner,
    InsuficienteBalance,
    MenssageAlert,
  },
  props: {
    campaignBalance: {
      type: Object,
      default: () => {
        return {
          campaignBalance: {
            channels: {
              email: {
                values: [],
              },
              sms: {
                values: [],
              },
            },
          },
        }
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
    campaignStatus: {
      type: String,
    },
  },
  data() {
    return {
      showSMSLocations: false,
      showSMSRoWLocations: false, // ? Expandir área de SMS do Resto do Mundo
      loadingSend: false,
    }
  },
  methods: {
    getFlag(key) {
      return countries.find((elm) => elm.code.toUpperCase() === key.toUpperCase())?.flag
    },
    clickToCancel() {
      this.$emit('cancel-campaign')
    },
    totalSMS(smsList) {
      let totalSms = 0
      let totalFaltando = 0
      if (Array.isArray(smsList)) {
        smsList.forEach((elm) => {
          totalSms += elm.balance
          totalFaltando += elm.remaining < 0 ? elm.remaining : 0
        })
      }

      return {
        totalToSend: totalSms,
        totalRemaining: totalFaltando,
      }
    },
    sendCampaign(hasInsuficienteBalance) {
      if (hasInsuficienteBalance) {
        return
      }

      if (this.hasReachedMaxDailySchedulingLimit) return

      this.messages = []
      this.loadingSend = true
      if (this.hasInsuficienteBalance) {
        this.loadingSend = false
        return
      }

      if (this.$route.params.campaignId) {
        let organizationId = this.$route.params.organizationId
        services
          .patchSendCampaign(organizationId, this.$route.params.campaignId)
          .then((res) => {
            this.$router.push({ name: 'campaignList' })
          })
          .catch(({ response }) => {
            this.messages.push({
              status: 'danger',
              text: response.data.title || response.data.message || 'Erro',
            })
          })
          .finally(() => {
            this.loadingSend = false
          })
      }
    },
  },
  computed: {
    hasInsuficienteBalance: function () {
      if (this.campaignBalance.campaign.channels.email.values.length > 0) {
        return (
          this.campaignBalance.campaign.channels.email.values[0].remaining < 0 ||
          this.totalSMS(this.campaignBalance.campaign.channels.sms.values).totalRemaining < 0
        )
      } else {
        return this.totalSMS(this.campaignBalance.campaign.channels.sms.values).totalRemaining < 0
      }
    },
    hasReachedMaxDailySchedulingLimit: function () {
      return this.campaignBalance.maxDailyLimitReached
    },
    emailValue: function () {
      if (this.campaignBalance.campaign.channels.email.values.length > 0) {
        return this.campaignBalance.campaign.channels.email.values[0]
      } else {
        return {
          verification: true,
          remaining: 0,
          balance: 0,
        }
      }
    },
    smsValue: function () {
      return this.campaignBalance.campaign.channels.sms.values ?? []
    },
  },
}
</script>
<style scoped lang="scss" src="@/assets/scss/_flow.scss"></style>
<style lang="scss" scoped>
.centralize {
  margin: auto !important;
}
.font-balance {
  font-size: $font-size-md2;
}

.resume-balance-area {
  background-color: $white;
}

.font-title-channels {
  font-size: $font-size-xs;
}

.font-sm {
  font-size: $font-size-xs;
  font-weight: 700;
}

.font-md {
  font-size: $font-size-base;
  font-weight: 500;
}

.font-title-values {
  font-size: $font-size-lg;
  font-weight: 300;
}

.disable-send {
  opacity: 0.5;
  cursor: not-allowed !important;
}

.scroll-area-locations {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 300px;
}

.border-locations {
  border-bottom: 1px solid $gray-200;
}

.send-cursor {
  cursor: pointer;
}

.collapse-sms-area {
  :hover {
    background-color: $gray-200;
  }
}

.invert-icon {
  transform: rotate(180deg);
}
</style>
